import React from 'react';
import PropTypes from 'prop-types';
import { useDictionary } from '../../../../utilities/hooks/UseDictionary';
import plusIcon from '../../../../assets/icons/ic_plus_dark.svg';
import minusIcon from '../../../../assets/icons/ic_minus.svg';

const ParticipantStepper = ({ value, min, max, onChange }) => {
	const dictionary = useDictionary();
	const numericValue = Number(value) || 0;
	const canDecrease = numericValue > min;
	const canIncrease = max === undefined || max === null || numericValue < max;

	return (
		<div className="participant-stepper">
			<button
				type="button"
				className="participant-stepper-minus"
				disabled={!canDecrease}
				onClick={() => onChange(numericValue - 1)}
				aria-label={dictionary.decrease}
			>
				<img src={minusIcon} alt="" />
			</button>
			<span className="participant-stepper-value">{numericValue}</span>
			<button
				type="button"
				className="participant-stepper-plus"
				disabled={!canIncrease}
				onClick={() => onChange(numericValue + 1)}
				aria-label={dictionary.increase}
			>
				<img src={plusIcon} alt="" />
			</button>
		</div>
	);
};

ParticipantStepper.propTypes = {
	value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
	min: PropTypes.number,
	max: PropTypes.number,
	onChange: PropTypes.func.isRequired
};

ParticipantStepper.defaultProps = {
	min: 0,
	max: undefined
};

export default ParticipantStepper;
